define( 'commons/global-help-configs/customizable-table-config',[],function() {
    return [ 
             {
                 // The configure button
                 element: '.configure-columns-btn',
                 intro: "If this button is visible, the data table is <b>customizable</b>. " +
                        "<br/>Click on it and select which field will be <b>displayed or not</b>. The configuration is <b>saved</b> in your user's profile.", 
                 position : 'left'
             },
             {
                 // Table header
                 element: 'table#data thead tr',
                 intro: "If the table is customizable, you can perform drag and drop to reorganize fields display order.", 
                 position : 'bottom-middle-aligned'
             },        
             {
                 // A particular table header
                 element: 'table#data thead tr th:first-child',
                 intro: "Just <b>drag</b> a particular header next to another one to reorganize fields.<br/>" +
                        "New configuration will be saved automatically.",
                 position : 'bottom-middle-aligned'
             }
    ];
});
